"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: set up I18n extraction and runtime delivery for realsies
exports.default = { t: (s) => s };
//# sourceMappingURL=setupI18n.js.map